import React, { useEffect, useState } from "react";
import "./header.scss";
import { Link, useLocation } from "react-router-dom";
import { Container, Nav, Navbar } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";
import navbarLogo from "../../assets/img/logo.png";

export default function Header() {
  const [activeSection, setActiveSection] = useState("home");
  const location = useLocation();

  // Detect active section logic
  useEffect(() => {
    // If on Home Page (or root)
    if (location.pathname === "/" || location.pathname === "/home") {
      const sections = document.querySelectorAll("section[id]");
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActiveSection(entry.target.id);
            }
          });
        },
        { threshold: 0.3 }
      );

      sections.forEach((section) => observer.observe(section));
      return () => observer.disconnect();
    } else {
      // If on specific pages, set active section based on route
      if (location.pathname === "/full-fleet") {
        setActiveSection("our_fleet");
      } else if (location.pathname === "/safety-guidelines") {
        setActiveSection("safety-guidelines");
      } else {
        setActiveSection(""); // Clear active state if on unknown page
      }
    }
  }, [location.pathname]);


  return (
    <React.Fragment>
      <Navbar expand="lg" className="my-navbar">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img
              src={navbarLogo}
              alt="Yacht Mumbai"
              height="40"
              className="d-inline-block align-top me-2"
            />
            Yacht Mumbai
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-end"
          >
            <Nav className="navbar-links" activeKey={activeSection}>
              {/* Home */}
              <Nav.Link
                as={HashLink}
                smooth
                to="/home#home"
                eventKey="home"
                className={activeSection === "home" ? "active" : ""}
              >
                Home
              </Nav.Link>

              {/* Experiences */}
              <Nav.Link
                as={HashLink}
                smooth
                to="/home#experiences"
                eventKey="experiences"
                className={activeSection === "experiences" ? "active" : ""}
              >
                Experiences
              </Nav.Link>

              {/* Fleet */}
              <Nav.Link
                as={Link}
                to="/full-fleet"
                eventKey="our_fleet"
                className={activeSection === "our_fleet" ? "active" : ""}
              >
                Our Fleet
              </Nav.Link>

              {/* SAFETY → NORMAL LINK (Another page) */}
              <Nav.Link
                as={Link}
                to="/safety-guidelines"
                eventKey="safety-guidelines"
                className={
                  activeSection === "safety-guidelines" ? "active" : ""
                }
              >
                Safety
              </Nav.Link>

              {/* Contact */}
              <Nav.Link
                as={HashLink}
                smooth
                to="/home#contact"
                eventKey="contact"
                className={`contact-us ${activeSection === "contact" ? "active" : ""
                  }`}
              >
                Contact Us
              </Nav.Link>

            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>


    </React.Fragment>
  );
}
